/**
 * Typed application config. Values resolve in this order:
 *   1. Runtime config (window.__NH_CONFIG__) — injected by the container at
 *      start from environment variables, so ONE build works across all
 *      environments (dev/staging/prod) without rebuilding.
 *   2. Build-time Vite env (import.meta.env.VITE_*) — for local `npm run dev`.
 *   3. Safe defaults.
 */
declare global {
  interface Window {
    __NH_CONFIG__?: { apiBaseUrl?: string; appName?: string; appVersion?: string };
  }
}

const runtime = (typeof window !== 'undefined' && window.__NH_CONFIG__) || {};

export const env = {
  apiBaseUrl: runtime.apiBaseUrl || import.meta.env.VITE_API_BASE_URL || '/api/v1',
  appName: runtime.appName || import.meta.env.VITE_APP_NAME || 'Nifty Hosting',
  appVersion: runtime.appVersion || import.meta.env.VITE_APP_VERSION || '1.0.0',
} as const;
